// import { LogLevel } from "@azure/msal-browser";

// /**
//  * Enter here the user flows and custom policies for your B2C application
//  * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
//  * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
//  */
// const clientId = "79a1b495-f50d-413c-be9e-13467bc82191";
// const tenantName = "CentAIT"; // Keep this as tenant name, not ID
// const tenantId = "5085285a-d470-4ef4-8ace-99a9266cf7e4";

// export const b2cPolicies = {
//     names: {
//         signUpSignIn: "B2C_1_signin_singup_dev",
//         forgotPassword: "B2C_1_password",
//         editProfile: "B2C_1_editprofile",
//     },
//     authorities: {
//         signUpSignIn: {
//             // Using tenant ID in the authority URL
//             authority: `https://login.microsoftonline.com/${tenantId}/B2C_1_signin_singup_dev`,
//         },
//         forgotPassword: {
//             authority: `https://login.microsoftonline.com/${tenantId}/B2C_1_password`,
//         },
//         editProfile: {
//             authority: `https://login.microsoftonline.com/${tenantId}/B2C_1_editprofile`,
//         },
//     },
//     // Using login.microsoftonline.com for tenant ID-based authentication
//     authorityDomain: `login.microsoftonline.com`,
// };

// /**
//  * Configuration object to be passed to MSAL instance on creation.
//  * For a full list of MSAL.js configuration parameters, visit:
//  * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
//  */
// export const msalConfig = {
//     auth: {
//         clientId: clientId,
//         authority: b2cPolicies.authorities.signUpSignIn.authority,
//         knownAuthorities: [b2cPolicies.authorityDomain],
//         redirectUri: '/',
//         postLogoutRedirectUri: '/',
//         navigateToLoginRequestUrl: false,
//     },
//     cache: {
//         cacheLocation: 'sessionStorage',
//         storeAuthStateInCookie: false,
//     },
//     system: {
//         loggerOptions: {
//             loggerCallback: (level, message, containsPii) => {
//                 if (containsPii) {
//                     return;
//                 }
//                 switch (level) {
//                     case LogLevel.Error:
//                         console.error(message);
//                         return;
//                     case LogLevel.Info:
//                         console.info(message);
//                         return;
//                     case LogLevel.Verbose:
//                         console.debug(message);
//                         return;
//                     case LogLevel.Warning:
//                         console.warn(message);
//                         return;
//                     default:
//                         return;
//                 }
//             },
//         },
//     },
// };

// /**
//  * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
//  * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
//  */
// export const protectedResources = {
//     apiTodoList: {
//         endpoint: 'http://localhost:3000/api/todolist',
//         scopes: {
//             // Using tenant ID for scope URLs
//             read: [`https://graph.microsoft.com/${tenantId}/TodoList/ToDoList.Read`],
//             write: [`https://graph.microsoft.com/${tenantId}/TodoList/ToDoList.ReadWrite`],
//         },
//     },
// };

// /**
//  * Scopes you add here will be prompted for user consent during sign-in.
//  * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
//  * For more information about OIDC scopes, visit:
//  * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
//  */
// export const loginRequest = {
//     scopes: ["openid", "profile"],
// };

import { LogLevel } from '@azure/msal-browser';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
const clientId = process.env.REACT_APP_AZURE_AD_B2C_CLIENT_ID;
const tenantName = process.env.REACT_APP_AZURE_AD_B2C_TENANT_NAME;



export const b2cPolicies = {
  names: {
    signUpSignIn: 'B2C_1_signin_singup_dev',
    forgotPassword: 'B2C_1_password',
    editProfile: 'B2C_1_editprofile',
  },
  authorities: {
    signUpSignIn: {
      authority: `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/B2C_1_signin_singup_dev`,
    },
    forgotPassword: {
      authority: `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/B2C_1_password`,
    },
    editProfile: {
      authority: `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/B2C_1_editprofile`,
    },
  },
  authorityDomain: `${tenantName}.b2clogin.com`,
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: clientId, //'09dd92cf-78ba-4c25-94b2-ec3f3ef84352', // This is the ONLY mandatory field that you need to supply.
    authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
    knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
    redirectUri: '/', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
  loggerCallback: (level, message, containsPii) => {
    if (containsPii) return;

    if (process.env.NODE_ENV === 'development') {
      switch (level) {
        case LogLevel.Error:
          // console.error(message);
          break;
        case LogLevel.Warning:
          // console.warn(message);
          break;
        case LogLevel.Info:
          // console.info(message);
          break;
        case LogLevel.Verbose:
          // console.debug(message);
          break;
        default:
          break;
      }
    }
  },
},
  
  },
};

 
/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
  apiTodoList: {
    endpoint: 'http://localhost:3000/api/todolist',
    scopes: {
      read: ['https://CentAIT.onmicrosoft.com/TodoList/ToDoList.Read'],
      write: ['https://CentAIT.onmicrosoft.com/TodoList/ToDoList.ReadWrite'],
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
// export const loginRequest = {
//     scopes: [...protectedResources.apiTodoList.scopes.read, ...protectedResources.apiTodoList.scopes.write],
// };
export const loginRequest = {
  scopes: ['https://CentAIT.onmicrosoft.com/webapp-idp-dev/PublicInfo.Read'],
};
